import { useEffect, useRef, useState } from "react";

/**
 * Crossfade stack of N atmospheric videos.
 * Renders ONE <video> per source; rotates which one has opacity=1.
 * Respects prefers-reduced-motion: shows only videos[0] static.
 */
export default function HeroBackgroundVideos({
  videos = [],
  poster,
  displayMs = 7000,
  fadeMs = 1500,
}) {
  const [active, setActive] = useState(0);
  const reduced = useRef(
    typeof window !== "undefined" &&
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
  );

  useEffect(() => {
    if (videos.length < 2 || reduced.current) return;
    const timer = setInterval(() => {
      setActive((a) => (a + 1) % videos.length);
    }, displayMs);
    return () => clearInterval(timer);
  }, [videos, displayMs]);

  if (videos.length === 0) return null;

  if (reduced.current) {
    return (
      <video
        className="absolute inset-0 w-full h-full object-cover"
        autoPlay muted loop playsInline preload="metadata" poster={poster}
      >
        <source src={videos[0]} type="video/mp4" />
      </video>
    );
  }

  return (
    <div className="absolute inset-0" data-testid="hero-videos">
      {videos.map((src, i) => (
        <video
          key={src}
          className="absolute inset-0 w-full h-full object-cover transition-opacity ease-in-out"
          style={{ transitionDuration: `${fadeMs}ms`, opacity: active === i ? 1 : 0 }}
          autoPlay muted loop playsInline preload="auto" poster={poster}
          data-testid={`hero-video-${i}`}
        >
          <source src={src} type="video/mp4" />
        </video>
      ))}
    </div>
  );
}
